import config from '../../config.js';

import { getProductSlug } from './ProductActions.js';

// Shared shipping / return policy blocks so the product page and the category
// listing (ItemList) expose the exact same Offer structure to search engines.
const SHIPPING_DESTINATION_COUNTRIES = ['FR', 'BE', 'DE', 'NL', 'UK', 'CH', 'LU', 'DK'];

const RETURN_POLICY_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

function getOfferShippingDetails(product) {
	return {
		'@type': 'OfferShippingDetails',
		shippingRate: {
			'@type': 'MonetaryAmount',
			value: '0',
			currency: 'EUR',
		},
		deliveryTime: {
			'@type': 'ShippingDeliveryTime',
			transitTime: {
				'@type': 'QuantitativeValue',
				minValue: '2',
				maxValue: '5',
				unitCode: 'd',
			},
			handlingTime: {
				'@type': 'QuantitativeValue',
				minValue: '0',
				maxValue: '1',
				unitCode: 'd',
			},
			cutoffTime: {
				'@type': 'QuantitativeValue',
				value: '10:00:00Z',
			},
			businessDays: {
				'@type': 'OpeningHoursSpecification',
				dayOfWeek: [
					'https://schema.org/Monday',
					'https://schema.org/Tuesday',
					'https://schema.org/Wednesday',
					'https://schema.org/Thursday',
					'https://schema.org/Friday',
				],
			},
		},
		weight: {
			'@type': 'QuantitativeValue',
			value: product.weightNet || product.weight,
			unitCode: 'kg',
		},
		shippingDestination: SHIPPING_DESTINATION_COUNTRIES.map(addressCountry => ({
			'@type': 'DefinedRegion',
			addressCountry,
		})),
	};
}

function getMerchantReturnPolicy() {
	return {
		'@type': 'MerchantReturnPolicy',
		applicableCountry: RETURN_POLICY_COUNTRIES,
		returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
		merchantReturnDays: 7,
		returnMethod: 'https://schema.org/ReturnByMail',
		returnFees: 'https://schema.org/ReturnShippingFees',
		returnShippingFeesAmount: {
			'@type': 'MonetaryAmount',
			value: '9.90',
			currency: 'EUR',
		},
	};
}

// Builds the full Offer JSON-LD object (including shippingDetails and
// hasMerchantReturnPolicy) shared between the product page and the category listing.
export function getProductOfferSchema(product, { locale, price, priceValidUntil = null, url = null } = {}) {
	const offerUrl = url || `${config.url}${locale}/${getProductSlug(product, locale)}`;
	return {
		'@type': 'Offer',
		price: `${price}`,
		priceCurrency: 'EUR',
		availability: 'https://schema.org/InStock',
		...(priceValidUntil ? { priceValidUntil } : {}),
		url: offerUrl,
		shippingDetails: getOfferShippingDetails(product),
		hasMerchantReturnPolicy: getMerchantReturnPolicy(),
	};
}
